import {useState} from "react";
import {
  Box, Button, Dialog, DialogTitle, DialogContent, IconButton,
  Grid, Typography, ListItemButton, ListItemText, Stack, Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {useTranslator} from "../context/TranslatorContext";
import {EU_LANGUAGES} from "../config/euLanguages";
import {ReactComponent as TranslateIcon} from "../assets/icons/Language--Streamline-Iconoir.svg";
import {useTheme} from "@mui/material/styles";

const LanguagePickerDialog = ({open, onClose, language, onChange}) => {
  const {messages} = useTranslator();
  const handlePick = (code) => {
    onChange(code);
    onClose();
  };
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{pr: 6}}>
        <Typography variant="h4"> {messages.select_language_title} </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{position: "absolute", right: 8, top: 8}}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Alert severity="info" variant="outlined">
            {messages.language_picker_hint}
          </Alert>
        </Box>
        <Grid container spacing={0.5} columns={12}>
          {EU_LANGUAGES.map(({code, native}) => (
            <Grid item xs={6} sm={4} key={code} sx={{mb: 0.5}}>
              <ListItemButton
                selected={code === language}
                onClick={() => handlePick(code)}
                sx={{
                  "borderRadius": 0.5,
                  "py": 0.75,
                  "px": 1,
                  "&.Mui-selected": {
                    bgcolor: "action.selected",
                    borderLeft: `4px solid ${theme.palette.primary.main}`,
                    pl: 0.5,
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body1" sx={{minWidth: 28}}>
                        {code.toUpperCase()}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="primary.main"
                      >
                        {native}
                      </Typography>
                    </Stack>
                  }
                />
              </ListItemButton>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const TranslatorWidget = () => {
  const {language, setLanguage} = useTranslator();
  const [openDlg, setOpenDlg] = useState(false);

  const active = EU_LANGUAGES.find((l) => l.code === language);
  const label = active ? active.native : "Language";

  return (
    <Box sx={{ml: 2}}>
      <Button
        variant="text"
        color="inherit"
        onClick={() => setOpenDlg(true)}
        aria-haspopup="dialog"
        aria-label="Select language"
      >
        <Stack spacing={1} sx={{justifyContent: "center", alignItems: "center", p: 1}}>
          <TranslateIcon className="nav-icon-large" />
          <Typography variant="body2">
            <span style={{
              display: "inline-flex", alignItems: "center"}}>
              <span style={{marginRight: 2}}>{label}</span>
              <KeyboardArrowDownIcon />
            </span>
          </Typography>
        </Stack>
      </Button>

      <LanguagePickerDialog
        open={openDlg}
        onClose={() => setOpenDlg(false)}
        language={language}
        onChange={setLanguage}
      />
    </Box>
  );
};

export default TranslatorWidget;
